import { Injectable } from '@angular/core';
import { Lookup } from '../models/Lookup';
import { OptionSet } from '../models/OptionSet';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class InstitutionDetailsService {

  SugChinuchList: OptionSet[];
  PikuachList: OptionSet[];
  MigzarList: OptionSet[];
  ShlavChinuchList: OptionSet[];
  MosadTypeList: OptionSet[];
  SchoolBusList: OptionSet[];
  DaysList: OptionSet[];
  ClassesList: OptionSet[];
  GendersList: OptionSet[];
  CitiesList: Lookup[];
  rout: string = "InstitutionDetailsActions";

  constructor(public dataService: DataService) { }

  GetInstitutionDetails() {
    let request = { Action: "GetInstitutionDetails" };
    return this.dataService.setRequstData(this.rout, request);
  }

  setLists(data) {    
    this.CitiesList = data.CitiesList;
    this.ClassesList = data.ClassesList;
    this.DaysList = data.DaysList;
    this.GendersList = data.GendersList;
    this.MigzarList = data.MigzarList;
    this.MosadTypeList = data.MosadTypeList;
    this.PikuachList = data.PikuachList;
    this.SchoolBusList = data.SchoolBusList;
    this.ShlavChinuchList = data.ShlavChinuchList;
    this.SugChinuchList = data.SugChinuchList;
  }

  saveInstitutionDetails(formValues) {    
    let request = { Action: "UpdateInstitutionDetails", Institution: formValues };
    return this.dataService.setRequstData(this.rout, request);
  }

  async getLogo(): Promise<Blob | null> {
    const res: any = await this.dataService.setRequstData(this.rout, { Action: "GetInstitutionLogo" });
    if (!res || this.dataService.IsError(res)) {
      return null;
    }
    const binary = atob(res);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes]);
  }

  async saveLogo(logo: Blob): Promise<boolean> {
    const dataUrl = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(logo);
    });
    const request = { Action: "SaveInstitutionLogo", LogoBase64: dataUrl.split(',')[1] };
    return await this.dataService.setRequstData(this.rout, request) === 'success';
  }

}
